import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import "./index.css";
import App from "./App";
import Commander, { PublicAPI } from "./commander";
import RoundPage from "./components/history/RoundPage";

const main = process.env.REACT_APP_MODE === "history" ? <RoundPage /> : <App />;

ReactDOM.render(
  <Provider store={store}> {main} </Provider>,
  document.getElementById("elysium-root")
);

let UI;
// in production resize is triggerd by the game-manager
if (process.env.NODE_ENV === "development") {
  const { innerWidth, innerHeight, devicePixelRatio } = window;
  UI = Commander;
  Commander.resize(innerWidth, innerHeight, devicePixelRatio);
  window.addEventListener("resize", () => {
    const { innerWidth, innerHeight, devicePixelRatio } = window;
    PublicAPI.resize(innerWidth, innerHeight, devicePixelRatio);
  });
} else {
  UI = PublicAPI;
}

window.Elysium = window.Elysium || {};
window.Elysium.UI = UI;

declare global {
  interface Window {
    Elysium: any;
  }
}
